import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarLayoutProps } from './SidebarLayout.types';
import { Loading } from '../../Loading';
import { useStyles } from './SidebarLayout.styles';
import { PageLayout } from '../PageLayout';

export const SidebarLayout = ({ sidebar, showPageLayout }: SidebarLayoutProps) => {
  const styles = useStyles();
  return (
    <div css={styles.root}>
      <section>{sidebar}</section>

      {showPageLayout ? (
        <PageLayout content={<Outlet />} />
      ) : (
        <section>
          <Suspense fallback={<PageLayout content={<Loading />} />}>
            <Outlet />
          </Suspense>
        </section>
      )}
    </div>
  );
};
